import { useEffect, useState } from "react";
import { isEncrypted, hasKeys, onKeys } from "./secure.js";
import { wrapState, subscribeKeyState } from "./offlineKeys.js";

// {encrypted, hasKey, wrap: 'missing'|'ok'|'stale'} of the encrypted offline copy, kept current.
export function useOfflineKeyState(tenant) {
  const read = () => ({ encrypted: isEncrypted(), hasKey: hasKeys(), wrap: tenant ? wrapState(tenant) : "missing" });
  const [st, setSt] = useState(read);
  useEffect(() => {
    const update = () => setSt(read());
    update();
    const a = subscribeKeyState(update);
    const b = onKeys(update);
    return () => { a(); b(); };
  }, [tenant]); // eslint-disable-line react-hooks/exhaustive-deps
  return st;
}
